import Table from "./Table";

import { AnyObject } from "../../models";

type TableComponent = typeof Table;

const Component = Table as AnyObject;

export default Component as TableComponent;
